var $5383fbac59264ffa$exports = {};
$5383fbac59264ffa$exports = {
    "close": `\xcenchide\u{163}i`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notificare`,
            other: ()=>`${formatter.number(args.count)} notific\u{103}ri`
        })}.`
};


export {$5383fbac59264ffa$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
